import { $ } from "@/common/Axios";

export default {
  /**
   * 教务通知
   */
  educateNotice: {
    /*
     * 添加
     * attach 附件 (string query )
     * content 内容 (string query )
     * dingFinishTime 钉钉提醒落地人时间 (string query )
     * finishStatus 完结状态 (string query )
     * id  (integer query )
     * latestFinishTime 最晚完成时间 (string query )
     * publishId 发布人 (integer query )
     * publishStatus 是否已经发布 (string query )
     * publishTime 发布时间 (string query )
     * senderIds 发送人id (string query )
     * serviceNoticeCount 服务通知数量 (integer query )
     * siteIds 学校id (string query )
     * title 标题 (string query )
     * tmplId 通知模板id (integer query )
     * unfinishCount 未完成通知数量 (integer query )
     * varContent 变量内容 (string query )
     */
    post: (p, c) => $.post("/api/bms/notice/educateNotice", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/notice/educateNotice", p, c),
  },
  educateNotice_addSender: {
    /*
     * 添加发送人
     * id 发送人id (integer query required)
     * type 发送人类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/notice/educateNotice/addSender", p, c),
  },
  educateNotice_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/educateNotice/details", p, c),
  },
  educateNotice_finish: {
    /*
     * 完结
     * finishStatus 完结状态 (string query required)
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/educateNotice/finish", p, c),
  },
  educateNotice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/educateNotice/list", p, c),
  },
  educateNotice_listAllSenders: {
    /*
     * 获取所有发送人id列表
     */
    get: (p, c) => $.get("/api/bms/notice/educateNotice/listAllSenders", p, c),
  },
  educateNotice_listSenderIds: {
    /*
     * 获取发送人id列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/educateNotice/listSenderIds", p, c),
  },
  educateNotice_listSiteIds: {
    /*
     * 获取学校列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/educateNotice/listSiteIds", p, c),
  },
  educateNotice_publish: {
    /*
     * 发布
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/educateNotice/publish", p, c),
  },
  educateNotice_refresh: {
    /*
     * 刷新
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/educateNotice/refresh", p, c),
  },
  educateNotice_removeSender: {
    /*
     * 删除发送人
     * id 发送人id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/notice/educateNotice/removeSender", p, c),
  },
  educateNotice_setSenderIds: {
    /*
     * 设置发送人id列表
     * id id (integer query required)
     * senderIds 发送人id列表 (array query required)
     */
    put: (p, c) => $.put("/api/bms/notice/educateNotice/setSenderIds", p, c),
  },

  /**
   * 通知额外字段
   */
  extraColumn: {
    /*
     * 添加
     * columnDisplayValue 字段关联值 (string query )
     * columnName 字段名称 (string query )
     * columnType 字段类型 (string query )
     * columnValue 字段实际值 (string query )
     * educateNoticeId 教务通知id (integer query )
     * id  (integer query )
     * studentId 学生id (integer query )
     */
    post: (p, c) => $.post("/api/bms/notice/extraColumn", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/notice/extraColumn", p, c),
  },
  extraColumn_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/notice/extraColumn/export", p, c),
  },
  extraColumn_list: {
    /*
     * 获取模块额外字段信息
     */
    get: (p, c) => $.get("/api/bms/notice/extraColumn/list", p, c),
  },
  extraColumn_listColumnName: {
    /*
     * 字段名称列表
     * educateNoticeId 教务通知id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/extraColumn/listColumnName", p, c),
  },
  extraColumn_uploadForStudent: {
    /*
     * 导入学生数据
     * educateNoticeId 教务通知id (integer query required)
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post("/api/bms/notice/extraColumn/uploadForStudent", p, c),
  },

  /**
   * 通知模板
   */
  noticeTmpl: {
    /*
     * 添加
     * contentType 内容类型：告知、信息收集、信息核对 (string query )
     * createId 创建人 (integer query )
     * id  (integer query )
     * infoColumns 信息字段 (string query )
     * needTeacherConfirm 是否需要班主任确认 (string query )
     * status 状态：未发布、已发布、已废弃 (string query )
     * tradeType 业务类型 (string query )
     * updateId 最近维护人 (integer query )
     * varNames 变量名称 (string query )
     * wechatTmplId 微信模板id (string query )
     */
    post: (p, c) => $.post("/api/bms/notice/noticeTmpl", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/notice/noticeTmpl", p, c),
  },
  noticeTmpl_abandon: {
    /*
     * 废弃
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/noticeTmpl/abandon", p, c),
  },
  noticeTmpl_getInfoColumns: {
    /*
     * 获取信息字段
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/getInfoColumns", p, c),
  },
  noticeTmpl_getVarNames: {
    /*
     * 获取变量名称
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/getVarNames", p, c),
  },
  noticeTmpl_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/list", p, c),
  },
  noticeTmpl_listAvailable: {
    /*
     * 可用变量列表
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/listAvailable", p, c),
  },
  noticeTmpl_listSimple: {
    /*
     * 默认模板简易列表
     * statuses 状态 (array query )
     */
    get: (p, c) => $.get("/api/bms/notice/noticeTmpl/listSimple", p, c),
  },
  noticeTmpl_publish: {
    /*
     * 发布
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/noticeTmpl/publish", p, c),
  },
  noticeTmpl_setInfoColumns: {
    /*
     * 设置信息字段
     * id id (integer query required)
     * infoColumns 信息字段 (string query required)
     */
    put: (p, c) => $.put("/api/bms/notice/noticeTmpl/setInfoColumns", p, c),
  },
  noticeTmpl_setVarNames: {
    /*
     * 设置变量名称
     * id id (integer query required)
     * varNames 变量名称 (array query required)
     */
    put: (p, c) => $.put("/api/bms/notice/noticeTmpl/setVarNames", p, c),
  },

  /**
   * 服务通知
   */
  serviceNotice: {
    /*
     * 添加
     * attach 附件 (string query )
     * content 内容 (string query )
     * educateNoticeId 教务通知id (integer query )
     * finishAttach 完成附件 (string query )
     * finishStatus 是否已完成 (string query )
     * finishTime 完成时间 (string query )
     * id  (integer query )
     * sendId 发送人id (integer query )
     * senderType 发送人类型（服务部、同行、教服、职教） (string query )
     * studentCount 学生数量 (integer query )
     * studentIds 学生id (string query )
     * studentUnconfirmCount 学生未确认数量 (integer query )
     * teacherUnconfirmCount 班主任未确认数量 (integer query )
     * title 标题 (string query )
     */
    post: (p, c) => $.post("/api/bms/notice/serviceNotice", p, c),
  },
  serviceNotice_deny: {
    /*
     * 拒绝打回
     * noticeId 通知id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/serviceNotice/deny", p, c),
  },
  serviceNotice_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/details", p, c),
  },
  serviceNotice_edit: {
    /*
     * 编辑
     * attach 附件 (string query )
     * content 内容 (string query )
     * educateNoticeId 教务通知id (integer query )
     * finishAttach 完成附件 (string query )
     * finishStatus 是否已完成 (string query )
     * finishTime 完成时间 (string query )
     * id  (integer query )
     * sendId 发送人id (integer query )
     * senderType 发送人类型（服务部、同行、教服、职教） (string query )
     * studentCount 学生数量 (integer query )
     * studentIds 学生id (string query )
     * studentUnconfirmCount 学生未确认数量 (integer query )
     * teacherUnconfirmCount 班主任未确认数量 (integer query )
     * title 标题 (string query )
     */
    put: (p, c) => $.put("/api/bms/notice/serviceNotice/edit", p, c),
  },
  serviceNotice_exportStudent: {
    /*
     * 导出学生列表
     * noticeId 通知id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/exportStudent", p, c),
  },
  serviceNotice_finish: {
    /*
     * 完成
     * finishAttach 完成附件 (string query )
     * noticeId 通知id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/serviceNotice/finish", p, c),
  },
  serviceNotice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/list", p, c),
  },
  serviceNotice_listFinishInfo: {
    /*
     * 获取通知完成情况
     * educateNoticeId 教务通知通知id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/listFinishInfo", p, c),
  },
  serviceNotice_listStudent: {
    /*
     * 获取学生列表
     * noticeId 通知id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/listStudent", p, c),
  },
  serviceNotice_restore: {
    /*
     * 修复服务通知
     */
    get: (p, c) => $.get("/api/bms/notice/serviceNotice/restore", p, c),
  },
  serviceNotice_send: {
    /*
     * 发送
     * noticeId 通知id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/notice/serviceNotice/send", p, c),
  },
  serviceNotice_uploadStudent: {
    /*
     * 上传学生列表
     * noticeId 通知id (integer query required)
     * studentIds 学生id（合同编号） (array query required)
     * type 类型：覆盖、新增 (string query required)
     */
    post: (p, c) => $.post("/api/bms/notice/serviceNotice/uploadStudent", p, c),
  },

  /**
   * 学生通知
   */
  studentNotice_confirmByStudent: {
    /*
     * 学生确认
     * id id (integer query required)
     * infoColumns 信息字段 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/notice/studentNotice/confirmByStudent", p, c),
  },
  studentNotice_confirmByTeacher: {
    /*
     * 老师确认
     * confirmAttach 确认附件 (string query )
     * confirmExtra 确认额外信息 (string query )
     * confirmRemark 确认备注 (string query )
     * id id (integer query required)
     * infoColumns 信息字段 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/notice/studentNotice/confirmByTeacher", p, c),
  },
  studentNotice_deny: {
    /*
     * 打回
     * confirmRemark 确认备注 (string query )
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/studentNotice/deny", p, c),
  },
  studentNotice_denyByEdu: {
    /*
     * 教务打回
     * id 学生通知id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/notice/studentNotice/denyByEdu", p, c),
  },
  studentNotice_details: {
    /*
     * 详情
     * id 学生通知ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/details", p, c),
  },
  studentNotice_detailsForClient: {
    /*
     * C端详情
     * serviceNoticeId 服务通知ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/notice/studentNotice/detailsForClient", p, c),
  },
  studentNotice_downloadTrackNumModule: {
    /*
     * 下载快递单号模板
     */
    get: (p, c) =>
      $.get("/api/bms/notice/studentNotice/downloadTrackNumModule", p, c),
  },
  studentNotice_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/export", p, c),
  },
  studentNotice_exportForEdu: {
    /*
     * 根据教务通知id导出
     * educateNoticeId 教务通知通知ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/exportForEdu", p, c),
  },
  studentNotice_exportForHeaderTeacher: {
    /*
     * 根据服务通知头老师导出
     * serviceNoticeId 服务通知ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/notice/studentNotice/exportForHeaderTeacher", p, c),
  },
  studentNotice_exportForSender: {
    /*
     * 根据服务通知发送人导出
     * serviceNoticeId 服务通知ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/exportForSender", p, c),
  },
  studentNotice_exportForSupervisor: {
    /*
     * 根据服务通知主管导出
     * serviceNoticeId 服务通知ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/notice/studentNotice/exportForSupervisor", p, c),
  },
  studentNotice_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/list", p, c),
  },
  studentNotice_listForClient: {
    /*
     * C端列表列表
     * statuses 状态 (array query )
     */
    get: (p, c) => $.get("/api/bms/notice/studentNotice/listForClient", p, c),
  },
  studentNotice_updateColumn: {
    /*
     * 更新字段
     * serviceNoticeId 服务通知id (integer query required)
     * studentId 学生id (integer query )
     */
    put: (p, c) => $.put("/api/bms/notice/studentNotice/updateColumn", p, c),
  },
  studentNotice_uploadTrackNum: {
    /*
     * 批量导入快递单号
     * file file (file formData required)
     * serviceNoticeId 服务通知id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/notice/studentNotice/uploadTrackNum", p, c),
  },
};
